import { AssetRef, Resource } from '../types';

export type MediaKind = 'image' | 'video' | 'audio';

const PREFIX: Record<MediaKind, string> = { image: '图片', video: '视频', audio: '音频' };

export function mediaKindOfRef(ref: AssetRef): MediaKind {
  return ref.source === 'shot_ref' ? 'video' : 'image';
}

export function mediaKindOfResource(res: Resource): MediaKind {
  return res.type === 'video' ? 'video' : res.type === 'audio' ? 'audio' : 'image';
}

export interface TokenLabel {
  kind: 'ref' | 'res';
  imgIndex?: number;
  resId?: string;
  token: string;
}

export function assignTypedTokens(refs: AssetRef[], resources: Resource[]): TokenLabel[] {
  const sortedRefs = [...refs].sort((a, b) => a.imgIndex - b.imgIndex);
  // 按真实时间(ms)排序，与后端 ResourceTimeLayout(纳秒固定宽度)的时间序一致；
  // 不要按 createdAt 字符串字典序排（JSON 里是 RFC3339Nano，裁剪末尾零会破坏字典序）。
  const sortedRes = [...resources].sort((a, b) => {
    const ta = new Date(a.createdAt || 0).getTime();
    const tb = new Date(b.createdAt || 0).getTime();
    if (ta !== tb) return ta - tb;
    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
  });
  const counters: Record<MediaKind, number> = { image: 0, video: 0, audio: 0 };
  const out: TokenLabel[] = [];
  for (const r of sortedRefs) {
    const k = mediaKindOfRef(r);
    counters[k] += 1;
    out.push({ kind: 'ref', imgIndex: r.imgIndex, token: `@${PREFIX[k]}${counters[k]}` });
  }
  for (const r of sortedRes) {
    const k = mediaKindOfResource(r);
    counters[k] += 1;
    out.push({ kind: 'res', resId: r.id, token: `@${PREFIX[k]}${counters[k]}` });
  }
  return out;
}
